var path = '/templates/zenclerk_s/agencies/campaigns/agency_campaigns.html';
var html = "<div><header>{{ 'agencies.campaigns.kyanpeen_ichiran' | translate }}</header><div class=container></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/agencies/campaigns/agency_campaigns.html
// module id = 1300
// module chunks = 0